export enum SettingTabId {
  UserList = 'user-list',
  OrganizationList = 'organization-list',
  Integration = 'integration',
  /** The old name of the Integration tab. Old links still work: they open Integration > EMR. */
  EmrIntegration = 'emr-integration',
  Roles = 'roles',
  SecurityScopes = 'security-scopes',
  Logs = 'logs',
  Profile = 'profile',
  Subscriptions = 'subscriptions',
  SyncAlerts = 'sync-alerts',
}

export enum LogsSubTabId {
  Audit = 'audit',
  Changelog = 'changelog',
  LoginActivity = 'login-activity',
  StaffUsage = 'staff-usage',
}

export enum IntegrationSubTabId {
  Emr = 'emr',
  Sling = 'sling',
}
